import { ReactNode } from 'react';
import { InventorySKUListing } from '@views/StockBySKU/components/types';
import { Modal } from '../Modal';
import { FloxSpinner } from '../FloxSpinner';
import { SkuInfoContent } from './SkuInfoContent';
import { useSkuDetails } from './useSkuDetails';

export interface SkuInfoModalProps {
  sku?: InventorySKUListing | null;
  inventorySkuId?: string | null;
  isOpen: boolean;
  onClose: () => void;
  actions?: ReactNode;
}

export function SkuInfoModal({
  sku,
  inventorySkuId,
  isOpen,
  onClose,
  actions,
}: SkuInfoModalProps) {
  const {
    sku: fetchedSku,
    isLoading,
    hasFailed,
  } = useSkuDetails(inventorySkuId, isOpen && !sku);

  const shownSku = sku ?? fetchedSku;

  return (
    <Modal isOpen={isOpen} setIsOpen={onClose} title='SKU Info'>
      <div className='w-full sm:w-[44rem] sm:max-w-full'>
        {isLoading && !shownSku && (
          <div className='flex justify-center py-12'>
            <FloxSpinner size='lg' />
          </div>
        )}
        {!isLoading && !shownSku && inventorySkuId && (
          <p className='py-12 text-center text-sm text-gray-500'>
            {hasFailed
              ? 'SKU details could not be loaded.'
              : 'No SKU details to show.'}
          </p>
        )}
        {shownSku && <SkuInfoContent sku={shownSku} />}
        {shownSku && actions && (
          <div className='flex justify-end gap-3 border-t border-gray-200 pt-4'>
            {actions}
          </div>
        )}
      </div>
    </Modal>
  );
}
